/* RESPONSIBLE TEAM: team-reporting */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  attrs: {
    admin: { key: 'created_by' },
  },
  collectionKey: 'notes',
});
